export function atLeastOneArrayItem<T>(array: T[]): T[] {
  return Array.isArray(array) && array.length > 0 ? array : [null];
}
